import { ActionTypes } from 'src/types/types';

export const FEATURE_NAME = 'events';

export const actionTypes = {
  FETCH_EVENTS: `${FEATURE_NAME}/FETCH_EVENTS`,
  FETCH_EVENTS_BY_SITE: `${FEATURE_NAME}/FETCH_EVENTS_BY_SITE`,
  FETCH_EVENT_BY_ID: `${FEATURE_NAME}/FETCH_EVENT_BY_ID`,
  FETCH_EVENT_BY_ID_LOADING: `${FEATURE_NAME}/FETCH_EVENT_BY_ID_LOADING`,
  FETCH_EVENT_TICKETS_WITHOUT_METRICS: `${FEATURE_NAME}/FETCH_EVENT_TICKET_WITHOUT_METRICS`,
  FETCH_EVENT_TICKETS: `${FEATURE_NAME}/FETCH_EVENT_TICKET`,
  FETCH_EVENT_LEAF_OCCURRENCES: `${FEATURE_NAME}/FETCH_EVENT_LEAF_OCCURRENCES`,
  UPDATE_EVENT: `${FEATURE_NAME}/UPDATE_EVENT`,
  CREATE_EVENT: `${FEATURE_NAME}/CREATE_EVENT`,
  CREATE_PREAPPROVED_EVENT: `${FEATURE_NAME}/CREATE_PREAPPROVED_EVENT`,
  SUBMIT_PREAPPROVED_EVENT: `${FEATURE_NAME}/SUBMIT_PREAPPROVED_EVENT`,
  DELETE_EVENT: `${FEATURE_NAME}/DELETE_EVENT`,
  COPY_EVENT: `${FEATURE_NAME}/COPY_EVENT`,
  CREATE_AI_EVENT: `${FEATURE_NAME}/CREATE_AI_EVENT`,
  UPDATE_EVENT_OCCURRENCE: `${FEATURE_NAME}/UPDATE_EVENT_OCCURRENCE`,
  CREATE_EVENT_OCCURRENCE: `${FEATURE_NAME}/CREATE_EVENT_OCCURRENCE`,
  FETCH_EVENT_OCCURRENCES: `${FEATURE_NAME}/FETCH_EVENT_OCCURRENCES`,
  CREATE_EVENT_TICKET: `${FEATURE_NAME}/CREATE_EVENT_TICKET`,
  UPDATE_EVENT_TICKET: `${FEATURE_NAME}/UPDATE_EVENT_TICKET`,
  DELETE_EVENT_TICKET: `${FEATURE_NAME}/DELETE_EVENT_TICKET`,
  FETCH_EVENT_TICKET: `${FEATURE_NAME}/FETCH_EVENT_TICKET`,
  CREATE_DATE_WITH_TIMES_EVENT_OCCURRENCE: `${FEATURE_NAME}/CREATE_DATE_WITH_TIMES_EVENT_OCCURRENCE`,
  UPDATE_DATE_WITH_TIMES_EVENT_OCCURRENCE: `${FEATURE_NAME}/UPDATE_DATE_WITH_TIMES_EVENT_OCCURRENCE`,
  DELETE_DATE_WITH_TIMES_EVENT_OCCURRENCE: `${FEATURE_NAME}/DELETE_DATE_WITH_TIMES_EVENT_OCCURRENCE`,
  UPDATE_EVENT_TICKETS_ORDER: `${FEATURE_NAME}/UPDATE_EVENT_TICKETS_ORDER`,
  FETCH_EVENT_PROMOS: `${FEATURE_NAME}/FETCH_EVENT_PROMOS`,
  CREATE_EVENT_PROMO: `${FEATURE_NAME}/CREATE_EVENT_PROMO`,
  UPDATE_EVENT_PROMO: `${FEATURE_NAME}/UPDATE_EVENT_PROMO`,
  DELETE_EVENT_PROMO: `${FEATURE_NAME}/DELETE_EVENT_PROMO`,
  UPDATE_EVENT_WAITLIST: `${FEATURE_NAME}/UPDATE_EVENT_WAITLIST`,
  NOTIFY_WAITLIST_SUBSCRIBERS: `${FEATURE_NAME}/NOTIFY_WAITLIST_SUBSCRIBERS`,
  GENERATE_AI_TEXT: `${FEATURE_NAME}/GENERATE_AI_TEXT`,
  FETCH_EVENT_HOSTS: `${FEATURE_NAME}/FETCH_EVENT_HOSTS`,
  CREATE_EVENT_HOST: `${FEATURE_NAME}/CREATE_EVENT_HOST`,
  UPDATE_EVENT_HOST: `${FEATURE_NAME}/UPDATE_EVENT_HOST`,
  DELETE_EVENT_HOST: `${FEATURE_NAME}/DELETE_EVENT_HOST`,
  INVITE_TEAM_MEMBER_AS_HOST: `${FEATURE_NAME}/INVITE_TEAM_MEMBER_AS_HOST`,
  ADD_EVENT_HOST_DIRECT: `${FEATURE_NAME}/ADD_EVENT_HOST_DIRECT`,
} satisfies ActionTypes<typeof FEATURE_NAME>;
